import React from "react";
import { Switch, Route } from "react-router-dom";
import { AdminPrivateRoute } from "../../components/AdminPrivateRoute";
import EditUser from "./EditUser";
import Home from "./Home";
import UserInvestments from "./UserInvestment";
import Payment from "./Payments";
import Users from "./Users";
import Dashboard from "./Dashboard";
import Currency from "./Currency";
// import Mail from "./Mail";

// import SendMail from "./SendMail";

const Admin = ({ match: { path } }) => {
  return (
    <Switch>
      <Route exact path={path}>
        <Home />
      </Route>
      <AdminPrivateRoute path={`${path}/dashboard`} component={Dashboard} />
      <AdminPrivateRoute path={`${path}/users`} component={Users} />
      <AdminPrivateRoute path={`${path}/user/:id`} component={EditUser} />
      <AdminPrivateRoute
        path={`${path}/payments`}
        component={Payment}
      ></AdminPrivateRoute>
      <AdminPrivateRoute
        path={`${path}/investments/:id`}
        component={UserInvestments}
      ></AdminPrivateRoute>
      <AdminPrivateRoute
        path={`${path}/currency`}
        component={Currency}
      ></AdminPrivateRoute>

      {/*    <AdminPrivateRoute path={`${path}/mail`} component={Mail} /> */}
    </Switch>
  );
};

export default Admin;
